export class StylingUtils {
    public static getPrimaryColor() {
        return this.readSCSSProperty('--fuse-primary');
    }

    public static readSCSSProperty(name: string): string {
        let bodyStyles = window.getComputedStyle(document.body);
        return bodyStyles.getPropertyValue(name);
    }
}
